import type {
	AllConditions as AC,
	ConditionProperties as CP,
	NotConditions as NC,
	AnyConditions as OC,
} from 'json-rules-engine';

/**
 * Make the operator become more strict by using enum instead of string only
 * Reference: https://github.com/CacheControl/json-rules-engine/blob/master/docs/rules.md#operators
 */
export enum ConditionOperators {
	/* Override Operators */
	Equal = 'equal',
	NotEqual = 'notEqual',
	In = 'in',
	NotIn = 'notIn',
	LessThan = 'lessThan',
	LessThanInclusive = 'lessThanInclusive',
	GreaterThan = 'greaterThan',
	GreaterThanInclusive = 'greaterThanInclusive',
	Contains = 'contains',
	DoesNotContain = 'doesNotContain',
	/* Custom Operators */
	StartWith = 'startWith',
	EndWith = 'endWith',
	IsEmpty = 'isEmpty',
	IsOverdue = 'isOverdue',
	IsNotOverdue = 'isNotOverdue',
}

export interface ConditionProperties extends CP {
	fact: string;
	operator: ConditionOperators;
	value: any;
}

export interface AndConditions extends Omit<AC, 'all'> {
	all: ConditionProperties[];
}

export interface OrConditions extends Omit<OC, 'any'> {
	any: ConditionProperties[];
}

export interface NotConditions extends Omit<NC, 'not'> {
	not: ConditionProperties[];
}

export type TopLevelOperators = 'any' | 'all' | 'not';
export type Conditions = AndConditions | OrConditions | NotConditions;
export type TopLevelCondition = Partial<
	Record<TopLevelOperators, Conditions[]>
>;
